import React, { useEffect, useState, PureComponent } from 'react';

import { ReactComponent as QrcodePurple } from '../assets/qrcode_purple.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';

import ActivityIcon from './ActivityIcon';

export default function Bio ({type, activity, remove, errors, register, name, icon, saveIcon, hideIcon}) {
    return (
        
        <>
        
            <div className="title"> 
                <div>
                    <div className="icon"><img src={icon} alt="" /></div>
                    <div className="name">Settings {name}</div>
                </div>
                <div>
                    <div className="icon qrcode"><QrcodePurple /></div>
                    <div className="icon remove" onClick={remove}><Remove /></div>
                </div>
            </div>

            <ActivityIcon icon={icon} saveIcon={saveIcon} hideIcon={hideIcon} />
            
            <label>Enter {name} name</label>
            <input 
                type="text"
                {...register("name", { required: "Name is required" })}
                placeholder={name + " name"}
                defaultValue={activity['name']}
            />
            <div className="error">{errors.name?.message}</div>                                
            
        </>
        
    )

}        
        
